import { combineReducers } from 'redux';
import { demographicsListPremiumReducer } from '~/store/demographics/premiumDemographics/demographicsListPremium.reducer';
import { demographicsListGlobalReducer } from './demographicsListGlobal/demographicsListGlobal.reducer';

export const demographicsReducer = combineReducers({
  listGlobal: demographicsListGlobalReducer,
  listPremium: demographicsListPremiumReducer,
});
